export default __webpack_public_path__ + "static/media/00.4d53eb14.jpg";